import React__default from 'react';
import Box from './Box.js';
import Typography from './Typography.js';
import Icon from './Icon.js';
import Pressable from './Pressable.js';
import 'styled-components';
import './useTheme.js';
import './global-2e5d81b9.js';
import './_commonjsHelpers-357b3b4e.js';

const Breadcrumbs = ({
  items,
  onPress,
  testID
}) => /*#__PURE__*/React__default.createElement(Box, {
  display: "flex",
  alignItems: "center",
  testID: testID
}, items.map((item, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Pressable, {
  onPress: () => item.redirect ? onPress(item.redirect) : undefined,
  disabled: !item.redirect,
  key: `breadcrumb-${item.text}`
}, /*#__PURE__*/React__default.createElement(Typography, {
  variant: "label-3",
  color: item.redirect ? 'primary' : 'quinary'
}, item.text)), index !== items.length - 1 && /*#__PURE__*/React__default.createElement(Box, {
  key: `separator-${item.text}`
}, /*#__PURE__*/React__default.createElement(Icon, {
  name: "24-breadcrumb-separator"
})))));

export { Breadcrumbs as default };
//# sourceMappingURL=Breadcrumbs.js.map
